/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RefreshIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function RefreshIcon({
  children,
  viewPath = "/DesignSystem/Svgs/RefreshIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="RefreshIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-keBjC': alignSelf,'--mt-2-keBjC': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-keBjC': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-keBjC': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-keBjC': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-keBjC': opacity,'--w-10-keBjC': typeof width === 'number' ? `${width}px` : width,'--h-11-keBjC': typeof height === 'number' ? `${height}px` : height,'--a-7-keBjC': isAnimated ? animation : "none",'--sd-8-keBjC': isAnimated ? strokeDashoffset : 0,'--sd-9-keBjC': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="RefreshIcon.SvgPath"
  data-view-path={viewPath}
 d="M2 2l2.94 2.94A9.944 9.944 0 002 12c0 5.514 4.486 10 10 10s10-4.486 10-10S17.514 2 12 2v2c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8c0-2.206.9-4.203 2.35-5.65L9 9V2H2z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}